import Money from 'common/Money';
import * as React from 'react';
import {AmountDisplay} from 'src/AmountDisplay';
import {ConsumptionsList} from 'src/ConsumptionsList';
import {BasisSection} from 'src/DetailComponents/BasisSection';
import Section from 'src/DetailComponents/Section';
import {DetailActions} from 'src/DetailComponents/Transaction/DetailActions';
import {PaymentDisplay} from 'src/DetailComponents/Transaction/Display';
import {Container, DetailHeader} from '.';
import type {DetailTransactionFragment} from '@transactions/graphql';

type Props = {
  payment: DetailTransactionFragment;
  onReset?: () => void;
  /** A line to pick out: the one a tap on an activity row came from. */
  highlightLineId?: string | null;
};

const PaymentDetail = (props: Props) => {
  const {payment} = props;
  return (
    <Container>
      <DetailHeader
        title={payment.payee || 'Untitled Payment'}
        amount={
          <AmountDisplay
            align="left"
            amount={Money.fromInt(payment.netAmount, payment.currency)}
            approx={
              payment.currency !== 'USD' && payment.homeNetAmount != null
                ? Money.fromInt(payment.homeNetAmount, 'USD')
                : null
            }
          />
        }
        actions={
          <DetailActions transaction={payment} onReset={props.onReset} />
        }
      />
      <Section header="Details">
        <PaymentDisplay payment={payment} />
      </Section>
      <BasisSection transaction={payment} />
      <Section header="Lines">
        <ConsumptionsList
          consumptions={payment.consumptions}
          highlightId={props.highlightLineId}
          currency={payment.currency}
        />
      </Section>
    </Container>
  );
};

export default PaymentDetail;
